import React from 'react'
import styled from 'styled-components';
import { useState, useEffect, useRef } from 'react';
import JoditEditor from 'jodit-react';
import { useSelector } from 'react-redux'
import useAuth from '../../../../features/hooks/useAuth'
import { useGetAssetMastersQuery } from '../../../../features/assetmasterApiSlice/assetmasterApiSlice'
import { useGetassetReqQuery, useUpdateassetReqMutation, useUpdateassetReqstatusMutation, useUpdateassetReqFinalMutation } from '../../../../features/assetrequest/assetReqApiSlice'
import { useGetUsersQuery, useAddUserAssetsMutation } from '../../../../features/users/usersApiSlice';
import { useGetofficesQuery } from '../../../../features/offices/officesApiSlice';
import { useGetAssetsFinalQuery, useUpdateAddAssetFinalMutation, useUpdateAssetintransitMutation } from '../../../../features/addassets/addassetfinalApiSlice'
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import { useGetStoreOfficesQuery } from '../../../../features/storeoffices/storeofficesApiSlice';
import { useAddNewassetTransMutation, useGetassetTransQuery, useUpdateassetTransMutation } from '../../../../features/assetTransApiSlice/assetTransApiSlice'
import EnhancedTable from './InboxFormTable'
import ReactTooltip from "react-tooltip";
import Divider from '@mui/material/Divider';
import moment from 'moment'
import { useGetofficeTransQuery, useAddNewofficeTransMutation, useUpdateofficeTransMutation } from '../../../../features/assetTransApiSlice/officeTransApiSlice'
import { useAddNewTransactionMutation } from '../../../../features/transactions/transactionsApiSlice'
import { HeadingWrap, Span, CommonButton, PreDataWrap, IntReqWrapper, RequestClosureWarapperAccepted, RequestClosureWarapperRejected, AddRemarkButton, BackButtonSpan } from '../../../../Styles/CommonStyles'

const Container = styled.div``
const Wrapper = styled.div`
display: flex;
flex-direction: column;
`
const ReqWrapper = styled.div``
const ExtReqWrapper = styled.div``
const AssetItemWrapper = styled.div`
display: flex;
margin: 10px;
align-items: center;
font-size: 20px;
`
const AssetItemsWrap = styled.span`
margin-right: 30px;
font-size: 20px;
`
const TextWrapper = styled.div`
font-size: 20px;
`
const UserNameContainer = styled.div`
padding-right: 30px;
font-size: 20px;
`
const PreDataCont = styled.div`
`
const FormContainer = styled.div``
const FormWrapper = styled.div``
const AssetFormContainer = styled.div`
`
const AssetFormWrapper = styled.div``
const TextFormCont = styled.div`
`
const FormItemsCont = styled.div`
display: flex;
align-items: center;
`
const InputFieldWrap = styled.div``
const SelectContainer = styled.div`
display: flex;
align-items: center;
`
const Option = styled.option`
font-weight: 100;
`
const Styledlabel = styled.label`
font-size: 20px;
font-weight: 200;
`
const CatSelect = styled.select`
width: 30%;
height: 35px;
`
const SubcatSelect = styled.select`
width: 30%;
height: 30px;
`
const AssetNameselCon = styled.div`
display: flex;
height: 5vh;
`
const AddButton = styled(CommonButton)``
const RemoveButton = styled(CommonButton)`
background-color: #fa4848;
`
const SubmitButton = styled(CommonButton)``

const ButtonContainer = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
`
const IntForwardButton = styled(CommonButton)``
const IntSendBacKButton = styled(CommonButton)``
const ExtForwardButton = styled(CommonButton)``
const ExtSendBacKButton = styled(CommonButton)``
const IntApproveButton = styled(CommonButton)``

const TimeAndNameCont = styled.div`
display: flex;
font-size: 20px;
justify-content: space-between;
`
const TimeWrapper = styled.div`
font-size: 20px;
`
const NoteCountCont = styled.div`
font-size: 22px;
font-weight: 600;
`
const BackArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
  cursor: pointer;
`
const StoreNameCont = styled.div`
display: flex;
align-items: center;
justify-content: center;
`
const AcceptAssetsButton = styled(CommonButton)``
const RejectionReqButton = styled(CommonButton)`
background-color: #f55239;
`
const RejectAssetsButton = styled(CommonButton)`
background-color: #f55239;
`
const OldAssetsCont = styled.div``
const OldAssetWrapper = styled.div`
display: flex;
`
const OldItemsWrapper = styled.div`
display: flex;
margin-right: 40px;
margin-bottom: 20px;`

const ItemContainer = styled.div`
display: flex;
background-color: #aae2e4;
width: 50vw;
align-items: center;
justify-content: space-between;
margin-top: 20px;
margin-bottom: 2px;
padding-top: 5px;
padding-bottom: 5px;
`
const Itemwrapper = styled.div`
display: flex;
width: 14vw;
`
const ItemLabelwrap = styled.div`
font-weight: 600;
margin-right: 30px;
font-size: 25px;
`
const ItemValWarap = styled.div`
display: flex;
justify-content: center;
align-items: center;
font-size: 20px;
`

// table style
const tableStyle = {
  width: '53%',
  borderCollapse: 'collapse',
  marginTop: '20px',
};

const thTdStyle = {
  border: '1px solid #ddd',
  padding: '8px',
  textAlign: 'left',
  fontSize: '20px'
};

const thStyle = {
  backgroundColor: '#aae2e4',
  fontSize: '23px'
};

const evenRowStyle = {
  backgroundColor: '#f9f9f9',
};

const InboxForm = ({ reqid, setChangepage }) => {
  const [field, setField] = useState([{ catName: "", assetName: "", quantity: "" }])
  const [content, setContent] = useState('');
  const [remarkButtonClicked, setRemarkButtonClicked] = useState(false)
  const editor = useRef(null);
  const [intSelectedAssets, setIntSelectedAssets] = useState([])
  const [sentTag, setSentTag] = useState('')
  const [reqStatus, setRequestStatus] = useState('')
  const [lastSavedAssetsinDb, setLastSavedAssetsinDb] = useState([])
  const [jsonData, setJsonData] = useState({ collection: "transactions", data: {}, type: "addnew", oldPath: "" });

  // logged in user info
  const { id, email, designation, designationSuffix, numSuffix, office, roles } = useAuth()
  let user_current_office = (useSelector((state) => state.office.off))
  let user_current_role_array = roles[user_current_office]

  //store offices 
  const {
    data: allstoreoffices
  } = useGetStoreOfficesQuery('allstorelists', {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true
  });

  let tempstoredata = allstoreoffices ? Object.values(allstoreoffices?.entities) : []
  let allstoresdata = tempstoredata

  //assetmaster call
  const {
    data: assetmasters,
    isLoading: assetmastLoad,

  } = useGetAssetMastersQuery('assetmasterlist', {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true
  });

  let tempdata = assetmasters ? Object.values(assetmasters?.entities) : []
  let data = tempdata

  //get single assets
  const { getSingleasset } = useGetAssetsFinalQuery('allassetlist', {
    selectFromResult: ({ data }) => ({
      getSingleasset: data?.entities
    }),
  })
  //Single user call
  const { getSingleuser } = useGetUsersQuery('userslist', {
    selectFromResult: ({ data }) => ({
      getSingleuser: data?.entities
    }),
  })

  //call single user data of the user logged in
  let singleUser_data = getSingleuser && getSingleuser[id]

  //Single Request call
  const { getSingleRequest } = useGetassetReqQuery('allassetReqlist', {
    selectFromResult: ({ data }) => ({
      getSingleRequest: data?.entities
    }),
  })

  const getCurrentDateISO = () => {
    const today = new Date();
    return today;
  }

  // call the req doc which is clicked
  let singleReq_data = getSingleRequest && getSingleRequest[reqid]

  // selected store office 
  let store_off = singleReq_data?.req_store

  // find applicable categories based on store of the request
  let selectedStoreDoc = allstoresdata.filter(elm => elm.storeoffice === store_off)
  let applCatarray = selectedStoreDoc[0]?.ApplAssetCateg

  // get last assets added
  // first find lastindex
  let lastassetind = singleReq_data.req_data?.findLastIndex(elm => elm.assets_details?.length > 0)
  let lastassetsArray = singleReq_data?.req_data[lastassetind]
  let templastassets = lastassetsArray?.assets_details
  let lastassets = [...templastassets]

  //Previous assets set
  useEffect(() => {
    if (singleReq_data?.req_cat === 'external') {
      setField(lastassets)
    }
    else {
      setIntSelectedAssets(lastassets)
    }
  }, [])

  //previous sent_to_tag
  useEffect(() => {
    singleReq_data && setSentTag(singleReq_data?.sent_to_tag)
    // current status of request 
    singleReq_data && setRequestStatus(singleReq_data?.curr_status)
  }, [])

  ////external request assets UI functions
  const handleChange = (index, event) => {
    if (event.target.name === 'catName') {
      let tempField = structuredClone(field);
      tempField[index][event.target.name] = event.target.value;
      tempField[index]["assetName"] = '';
      setField(tempField);
    }

    if (['assetName', 'quantity'].includes(event.target.name)) {
      let tempField = structuredClone(field);
      tempField[index][event.target.name] = event.target.value;
      setField(tempField);
    }
  }

  const handleAddClick = () => {
    setField([...field, { catName: "", assetName: "", quantity: "" }])
  }
  const handleRemoveClick = (index) => {
    const values = [...field]
    values.splice(index, 1)
    setField(values)
  }

  // all office call
  const {
    data: allofficedata,
    isLoading: allofficeLoad,
  } = useGetofficesQuery('officelist', {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true
  });

  //reqUpdate mutation
  const [updateReq, { isLoading: updateaddassetloading }] = useUpdateassetReqMutation()

  //reqStatus Update Mutation
  const [updateReqStatus, { isLoading: updateaddassetreqStatusloading }] = useUpdateassetReqstatusMutation()

  let tempallofficedata = allofficedata ? Object.values(allofficedata?.entities) : []
  const officedata = tempallofficedata

  //sent to BO by user logic
  let useroffice = officedata?.filter(elm => elm.name === user_current_office)
  let Bo_id = useroffice[0]?.Bo

  let sendtoboObj = { id: Bo_id, name: getSingleuser && getSingleuser[Bo_id]?.name, office: user_current_office, designation: getSingleuser && getSingleuser[Bo_id]?.designation[user_current_office], designationSuffix: getSingleuser && getSingleuser[Bo_id]?.designationSuffix[user_current_office], numSuffix: getSingleuser && getSingleuser[Bo_id]?.numSuffix[user_current_office] }

  //sent to Assetmanager level-1 obj (not for seennding but for transaction of external request)
  // find assetmanger level -1 Id (for unithead role)
  let assetManagerL1Id = selectedStoreDoc[0]?.roleUsers.L1ReqApprover

  let sendtoassetManagerL1Obj = { id: assetManagerL1Id, name: getSingleuser && getSingleuser[assetManagerL1Id]?.name, office: store_off, designation: getSingleuser && getSingleuser[assetManagerL1Id]?.designation[store_off], designationSuffix: getSingleuser && getSingleuser[assetManagerL1Id]?.designationSuffix[store_off], numSuffix: getSingleuser && getSingleuser[assetManagerL1Id]?.numSuffix[store_off] }

  // create sent to Bo(Com) object
  let senttoboUpdateData = {
    sent_to_tag: 'bo',
    assets_details: singleReq_data?.req_cat === 'internal' ? intSelectedAssets : field,
    Text: content,
    sent_by: { id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
    sent_to: sendtoboObj,
    status: singleReq_data?.curr_status,
    time_stamp: new Date()
  }

  let senttoboBody = { id: reqid, senttoboUpdateData: senttoboUpdateData }
  // let senttoassetmanagerL1Body = { id: reqid, senttoassetmanagerL1UpdateData: senttoassetmanagerL1UpdateData }

  // last assets and approved assets logic
  //for external
  let lastblockedassetind = singleReq_data?.req_data.findLastIndex(elm => elm.blocked_assets)
  // get last assets details internal
  let index_last_assets = singleReq_data?.req_data.findLastIndex(elm => elm.assets_details)

  // last modified assets ID array (same are last approved also)
  let lastmodifiedasset = []
  if (singleReq_data.req_cat === 'internal') {
    lastmodifiedasset = singleReq_data?.req_data[index_last_assets].assets_details
  }
  else if (singleReq_data.req_cat === 'external') {
    lastmodifiedasset = singleReq_data?.req_data[lastblockedassetind]?.blocked_assets
  }

  let approvedAssetsArray = (['issued', 'partialissuecreated'].includes(singleReq_data?.curr_status)) && lastmodifiedasset

  useEffect(() => {
    setLastSavedAssetsinDb(lastmodifiedasset)
  }, [])

  //update User Call
  const [addUserAsset, { isLoading: addUserassetloading }] = useAddUserAssetsMutation()

  //update assets call
  const [updateasset, { isLoading: updateassetloading }] = useUpdateAddAssetFinalMutation()

  //update assets in transit
  const [updateAssetinTran, { isLoading: updateAssetinTranloading }] = useUpdateAssetintransitMutation()

  let oldassetsarray = lastSavedAssetsinDb
  let newselectedArray = intSelectedAssets

  //filter old asset array which are not common in newselected
  let oldnotintransitarray = oldassetsarray?.filter((el) => !newselectedArray.includes(el));

  // body to update assets intransit status
  let updatedintransitbody = { selectedAssetarray: newselectedArray, transtatus: true }
  let notintransitassetarray = { selectedAssetarray: oldnotintransitarray, transtatus: false }

  // selecetd user id to be inserted in all assets to be issued// alongwith final in transit status false
  let dataForUpdate = {
    cur_loc: "user", cur_loc_name: `${singleUser_data?.name?.firstName} ${singleUser_data?.name?.middleName} ${singleUser_data?.name?.lastName}-${user_current_office}-${designation[user_current_office]}-${designationSuffix[user_current_office]}`, in_transit: false, alloc_user: id,
    alloc_ofc: user_current_office, last_trans_date: new Date()
  }

  let assetsUpdateBody = { assetIdArray: approvedAssetsArray, ...dataForUpdate }

  // body to be updated in user collection
  let userUpdateBody = { id: id, [user_current_office]: approvedAssetsArray }

  //updated asset req sent to bo by user 
  const handleSendtoboHandler = async () => {

    if (!Bo_id) {
      return alert('Branch Officer is not registered.Please register the Branch Officer')
    }
    else {
      // for internal request assets to be done in transit and not in transit as per change in assets selected 
      // there will always be new selected ( user eiter changes or does not change the old assets)
      // new selected assets to do in transit 
      if (singleReq_data.req_cat === 'internal') {
        try {
          await updateAssetinTran(updatedintransitbody)
        } catch (err) {
          return alert(`Error:${err}`)
        }
      }
      // old assets which are not in common with new selected to be done in non transit
      if (singleReq_data.req_cat === 'internal' && oldnotintransitarray.length > 0) {
        try {
          await updateAssetinTran(notintransitassetarray)
        } catch (err) {
          return alert(`Error:${err}`)
        }
      }
      // update req
      try {
        // update req body
        await updateReq(senttoboBody)
        setChangepage([true, false, false, false])
        return alert('Sent to Branch officer')
      } catch (err) {
        return alert(`Error:${err}`)
      }
    }
  }

  const [addTrans, { isLoading: addTransloading }] = useAddNewTransactionMutation()

  // // asset transaction body logic.
  // //all assets_trans call 
  // const {
  //   data: assetTransdata,
  //   isLoading: TransLoading,
  // } = useGetassetTransQuery('translist', {
  //   refetchOnFocus: true,
  //   refetchOnMountOrArgChange: true
  // });

  // let assetTrans = assetTransdata ? Object.values(assetTransdata?.entities) : []

  // const [addNewassetTrans, { isLoading: addNewtransloading }] = useAddNewassetTransMutation()
  // const [updateAssetTrans, { isLoading: updatetransloading }] = useUpdateassetTransMutation()

  let assetsbeingissuedIds = lastmodifiedasset

  // // we don't know if, in the assets being issued how many have alraedy been transacted and how many are going first time in the transaction.
  // //so first search for transaction IDs of alraedy existing transactions of assets
  // let transactionIdsofoldassets = assetTrans?.filter(elm => lastmodifiedasset?.includes(elm.asset_id))?.map(elm => { return elm._id })

  // //now find assets IDs of already existing transactions
  // let assetIdswitholdTrans = assetTrans?.filter(elm => lastmodifiedasset?.includes(elm.asset_id)).map(elm => { return elm.asset_id })

  // //now filter assets Ids for which first time transactions will be created.
  // let assetIdswithnewTrans = assetsbeingissuedIds?.filter(elm => !assetIdswitholdTrans.includes(elm))

  // let TransData =
  // {
  //   uniqueReqId: singleReq_data?.singleReq_data,
  //   sent_from: singleReq_data.req_cat === 'internal' ? user_current_office : singleReq_data.req_store,
  //   sent_to: `${getSingleuser && getSingleuser[id]?.name?.firstName} ${getSingleuser && getSingleuser[id]?.name?.middleName} ${getSingleuser && getSingleuser[id]?.name?.lastName}`,
  //   handover_by: singleReq_data.req?.req_cat === 'internal' ? sendtoboObj : sendtoassetManagerL1Obj,
  //   received_by: { id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
  //   time_stamp: new Date()
  // }

  // // new asset transaction body
  // let newTranslist = assetIdswithnewTrans?.map(elm => { return { asset_id: elm, trans_data: [TransData] } })

  // // old asset transaction body
  // let oldTranslist = { IdsArray: transactionIdsofoldassets, trans_data: TransData }

  //update asset request final update for acceptance and rejection
  const [updateassetReqfinal, { isLoading: updateassetReqFinalloading }] = useUpdateassetReqFinalMutation()
  //***************************************************************************************************************************** */


  //******************************************office transactions-Issues****************************************/
  // const {
  //   data: officeTransdata,
  //   isLoading: officeTransLoading,

  // } = useGetofficeTransQuery('officetranslist', {
  //   refetchOnFocus: true,
  //   refetchOnMountOrArgChange: true
  // });

  // let officeTrans = officeTransdata ? Object.values(officeTransdata?.entities) : []

  // const [addNewOffIssueTrans, { isLoading: addNewOffIssuetransloading }] = useAddNewofficeTransMutation()
  // const [updateOffIssueTrans, { isLoading: updateOffIssuetransloading }] = useUpdateofficeTransMutation()

  // //so first search for ID of transactions for 'Issue' already existing office
  // let transObjofOfficTrans = officeTrans?.filter(elm => (elm.office === user_current_office) && (elm.transact_for === 'issue'))[0]
  // let transIdofOfficTrans = transObjofOfficTrans?._id

  // let offTransData =
  // {
  //   uniqueReqId: singleReq_data?.uniqueReqId,
  //   assets: assetsbeingissuedIds,
  //   handover_by: sendtoassetManagerL1Obj,
  //   received_by: { id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
  //   time_stamp: new Date()
  // }

  // // new office 'issue' transaction body
  // let newoffTranslist = { office: user_current_office, transact_for: "issue", trans_data: [offTransData] }

  // // old office 'issue' transaction body
  // let oldoffTranslist = { Trans_Id: transIdofOfficTrans, trans_data: offTransData }



  //***************Assets transactions**************************************************/
  const transacData = {
    transac_id: singleReq_data?.uniqueReqId,
    req_id: "",
    asset_id: assetsbeingissuedIds,
    transac_type: "issue",
    indi_asset: false,
    from_userid: getSingleuser?.[singleReq_data?.issuer?.id]?.email || singleReq_data?.issuer?.email,
    from_office: singleReq_data?.issuer?.office,
    from_desig: singleReq_data?.issuer?.designation,
    from_store: "",
    to_userid: email,
    to_office: user_current_office,
    to_desig: designation[user_current_office],
    to_store: "",
    pdfPath: "",
    time_stamp: getCurrentDateISO()
  }

  //#############################// accept handler //#######################
  const acceptHandler = async () => {
    if (singleReq_data.curr_status === 'partialissuecreated') {
      //update status body for accept and insert closure time stamp
      let partialacceptReqObj = {
        curr_status: "partialissueaccepted",
        close_time_stamp: new Date()
      }

      //update req also to keep time stamp of acceptance for closure
      let updatReqAcceptBody = { id: reqid, finalReqObj: partialacceptReqObj }

      // asset transaction logic 
      //**************************************** */
      await addTrans(transacData)
      // // for those assets which are being first time transacted 
      // if (assetIdswithnewTrans.length > 0) {
      //   try {
      //     await addNewassetTrans({ newTranslist: newTranslist })
      //   } catch (err) {
      //     return alert(`Error:${err}`)
      //   }
      // }
      // // for those assets whose transactions already exits
      // if (transactionIdsofoldassets.length > 0) {
      //   try {
      //     await updateAssetTrans(oldTranslist)
      //   } catch (err) {
      //     return alert(`Error:${err}`)
      //   }
      // }

      // office transaction for issue for external request
      //************************************************** */
      // if (singleReq_data.req_cat === 'external') {
      //   //transaction  
      //   if (transIdofOfficTrans) {
      //     await updateOffIssueTrans(oldoffTranslist)
      //   } else {
      //     await addNewOffIssueTrans(newoffTranslist)
      //   }
      // }

      //others APIs
      try {
        //Req update with status of request for acceptance
        await updateassetReqfinal(updatReqAcceptBody)
        //update user document by inserting the assets office and assets Ids.
        await addUserAsset(userUpdateBody)
        // update assets by inserting user Id in all issued assets.
        await updateasset(assetsUpdateBody)
        setChangepage([true, false, false, false, false])
        return alert('partial Assets accepted.')
      } catch (err) {
        return alert(`Error:${err}`)
      }
    } else {
      //update status body for accept and insert closure time stamp
      let acceptReqObj = {
        curr_status: "accepted",
        close_time_stamp: new Date()
      }
      //update req also to keep time stamp of acceptance for closure
      let updatReqAcceptBody = { id: reqid, finalReqObj: acceptReqObj }
      await addTrans(transacData)

      // asset transaction logic 
      //******************************************** */
      // for those assets which are being first time transacted 
      // if (assetIdswithnewTrans.length > 0) {
      //   try {
      //     await addNewassetTrans({ newTranslist: newTranslist })
      //   } catch (err) {
      //     return alert(`Error:${err}`)
      //   }
      // }
      // for those assets whose transactions already exits
      // if (transactionIdsofoldassets.length > 0) {
      //   try {
      //     await updateAssetTrans(oldTranslist)
      //   } catch (err) {
      //     return alert(`Error:${err}`)
      //   }
      // }
      // office transaction for issue for external request
      // if (singleReq_data.req_cat === 'external') {
      //   //transaction  
      //   if (transIdofOfficTrans) {
      //     await updateOffIssueTrans(oldoffTranslist)
      //   } else {
      //     await addNewOffIssueTrans(newoffTranslist)
      //   }
      // }
      //others APIs
      try {
        //Req update with status of request for acceptance
        await updateassetReqfinal(updatReqAcceptBody)
        //update user document by inserting the assets office and assets Ids.
        await addUserAsset(userUpdateBody)
        // update assets by inserting user Id in all issued assets.
        await updateasset(assetsUpdateBody)
        setChangepage([true, false, false, false, false])
        return alert('Assets accepted and this request is closed')
      } catch (err) {
        return alert(`Error:${err}`)
      }
    }
  }

  //rejection req by user 
  // update status
  let updateStatusrejectreqBody = { id: reqid, curr_status: 'reject_req' }
  // rejection req handler
  const rejectionreqHandler = async () => {
    try {
      // status of request to be accepted & closure time stamp
      await updateReqStatus(updateStatusrejectreqBody)
      return alert('Assets rejection request created sent further to BO or assetmanager')
    } catch (err) {
      return alert(`Error:${err}`)
    }
  }

  //#############################// reject handler//##################################
  let rejectReqObj = {
    curr_status: "rejected",
    close_time_stamp: new Date()
  }
  // update req also to keep time stamp of acceptance for closure
  let updatReqRejectBody = { id: reqid, finalReqObj: rejectReqObj }
  // change in_transition status of the issued assets
  let finalnontransitbody = { selectedAssetarray: lastmodifiedasset, transtatus: false }
  // reject handler
  const rejectHandler = async () => {
    try {
      //update req body and status for rejection
      await updateassetReqfinal(updatReqRejectBody)
      // make issued assets in non-transit
      await updateAssetinTran(finalnontransitbody)
      setChangepage([true, false, false, false, false])
      return alert('Assets rejected and this request is closed')
    } catch (err) {
      return alert(`Error:${err}`)
    }
  }

  return (
    <Container>
      <BackArrowContainer onClick={() => setChangepage([true, false, false, false, false])}><ArrowLeftIcon /><BackButtonSpan >Back to Category Table</BackButtonSpan></BackArrowContainer>
      {(singleReq_data?.curr_status !== 'rejected') && (singleReq_data?.curr_status !== 'accepted') && <AddRemarkButton onClick={() => setRemarkButtonClicked(true)}>Add Remark</AddRemarkButton>}
      <Wrapper>
        <ReqWrapper>
          {singleReq_data?.req_cat === 'internal' && <>  <HeadingWrap>
            <Span>Request category : Internal</Span>
          </HeadingWrap><IntReqWrapper>
              <PreDataCont>
                {getSingleRequest[reqid]?.req_data.map((elm, ind) =>
                  <PreDataWrap key={ind}>
                    <HeadingWrap>
                      <NoteCountCont>Note-{ind + 1}</NoteCountCont>
                    </HeadingWrap>
                    {elm.assets_details && <div style={{ margin: '15px' }}><span style={{ fontSize: '20px' }}>Requested Asset Details (selected in the checkbox):</span></div>}
                    {elm.assets_details && <EnhancedTable prevData={true} intSelectedAssets={elm.assets_details} reqStatus={reqStatus} />}
                    <TextWrapper>
                      Remark: <div dangerouslySetInnerHTML={{ __html: elm.Text }} />
                    </TextWrapper>
                    <TimeAndNameCont>
                      <TimeWrapper>
                        {getSingleRequest[reqid]?.req_data[getSingleRequest[reqid]?.req_data.length - 1].time_stamp}
                      </TimeWrapper>
                      <UserNameContainer>
                        {`${getSingleRequest[reqid]?.req_data[ind].sent_by?.name?.firstName} ${getSingleRequest[reqid]?.req_data[ind].sent_by?.name?.middleName} ${getSingleRequest[reqid]?.req_data[ind].sent_by?.name?.lastName}-${getSingleRequest[reqid]?.req_data[ind].sent_by?.office}-${getSingleRequest[reqid]?.req_data[ind].sent_by?.designation} ${getSingleRequest[reqid]?.req_data[ind].sent_by?.designationSuffix}`}
                      </UserNameContainer>
                    </TimeAndNameCont>
                  </PreDataWrap>)}
              </PreDataCont>
              {remarkButtonClicked && (singleReq_data.curr_status !== 'issued') && (singleReq_data.curr_status !== 'reject_req') && (singleReq_data?.curr_status !== 'rejetion_enabled') && (singleReq_data?.curr_status !== 'rejected') && (singleReq_data?.curr_status !== 'accepted') && <FormContainer>
                <FormWrapper>
                  <AssetFormContainer>
                    <AssetFormWrapper>
                      <EnhancedTable prevData={false} intSelectedAssets={intSelectedAssets} setIntSelectedAssets={setIntSelectedAssets} sentTag={sentTag} reqStatus={reqStatus} lastSavedAssetsinDb={lastSavedAssetsinDb} />
                    </AssetFormWrapper>
                  </AssetFormContainer>
                </FormWrapper>
              </FormContainer>}
            </IntReqWrapper></>}
          {singleReq_data?.req_cat === 'external' && <> <HeadingWrap>
            <Span>Request category : External</Span>
          </HeadingWrap> <ExtReqWrapper>
              <PreDataCont>
                <StoreNameCont><Span style={{ fontSize: '20px' }}>Requested Store: {store_off}</Span></StoreNameCont>
                {getSingleRequest[reqid]?.req_data?.map((elm, ind) =>
                  <PreDataWrap key={ind}>
                    <HeadingWrap>
                      <NoteCountCont>Note-{ind + 1}</NoteCountCont>
                    </HeadingWrap>
                    {elm.assets_details && <div style={{ margin: '15px' }}><span style={{ fontSize: '20px' }}>Requested Asset Details:</span></div>}
                    {elm.assets_details && elm.assets_details?.map((elem, index) => <AssetItemWrapper key={index}>
                      <ItemContainer>
                        <Itemwrapper>
                          <ItemLabelwrap>
                            Category:
                          </ItemLabelwrap>
                          <ItemValWarap>
                            {elem.catName}
                          </ItemValWarap>
                        </Itemwrapper>
                        <Itemwrapper>
                          <ItemLabelwrap>
                            AssetName:
                          </ItemLabelwrap>
                          <ItemValWarap>
                            {elem.assetName}
                          </ItemValWarap>
                        </Itemwrapper>
                        <Itemwrapper>
                          <ItemLabelwrap>
                            Quantity:
                          </ItemLabelwrap>
                          <ItemValWarap>
                            {elem.quantity}
                          </ItemValWarap>
                        </Itemwrapper>
                      </ItemContainer>
                      <Divider />
                    </AssetItemWrapper>)}
                    {elm.blocked_assets && getSingleasset && <OldAssetsCont>
                      <Span> Proposed assets details: </Span>
                      {elm.blocked_assets && <OldAssetWrapper>
                        <table style={tableStyle}>
                          <thead>
                            <tr>
                              <th style={{ ...thTdStyle, ...thStyle }}>Assets</th>
                              <th style={{ ...thTdStyle, ...thStyle }}>OEM Tags</th>
                              <th style={{ ...thTdStyle, ...thStyle }}>OEM/Brand</th>
                              <th style={{ ...thTdStyle, ...thStyle }}>Purchase Date</th>
                              <th style={{ ...thTdStyle, ...thStyle }}>Warranty Date</th>
                              <th style={{ ...thTdStyle, ...thStyle }}>Specifications</th>
                            </tr>
                          </thead>
                          <tbody>
                            {elm.blocked_assets?.map(element => { return getSingleasset && getSingleasset[element] })?.map((row, index) => (
                              <tr key={index} style={(index + 1) % 2 === 0 ? evenRowStyle : null}>
                                <td style={thTdStyle}>{row.name}</td>
                                <td style={thTdStyle}>{row.oem_tag}</td>
                                <td style={thTdStyle}>{row.oem}</td>
                                <td style={thTdStyle}>{moment(row.purchase_date).format('DD/MM/YYYY')}</td>
                                <td style={thTdStyle}>{moment(row.warrantyexp_date).format('DD/MM/YYYY')}</td>
                                <td style={thTdStyle}><div className="App">
                                  <div data-tip data-for={row._id}>
                                    Hover here to view Specifications
                                  </div>
                                  <ReactTooltip id={row._id} place="top" effect="solid">
                                    <div>
                                      {Object.entries(row.specification).map(([key, val]) => <h4 key={key}>{key}: {val}</h4>)}
                                    </div>
                                  </ReactTooltip>
                                </div></td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </OldAssetWrapper>}
                    </OldAssetsCont>}
                    <TextWrapper>
                      Remark: <div dangerouslySetInnerHTML={{ __html: elm.Text }} />
                    </TextWrapper>
                    <TimeAndNameCont>
                      <TimeWrapper>
                        {getSingleRequest[reqid]?.req_data[getSingleRequest[reqid]?.req_data.length - 1].time_stamp}
                      </TimeWrapper>
                      <UserNameContainer>
                        {`${getSingleRequest[reqid]?.req_data[ind].sent_by?.name?.firstName} ${getSingleRequest[reqid]?.req_data[ind].sent_by?.name?.middleName} ${getSingleRequest[reqid]?.req_data[ind].sent_by?.name?.lastName}-${getSingleRequest[reqid]?.req_data[ind].sent_by?.office}-${getSingleRequest[reqid]?.req_data[ind].sent_by?.designation} ${getSingleRequest[reqid]?.req_data[ind].sent_by?.designationSuffix}`}
                      </UserNameContainer>
                    </TimeAndNameCont>
                  </PreDataWrap>)}
              </PreDataCont>
              {remarkButtonClicked && <FormContainer>
                <FormWrapper>
                  <AssetFormContainer>
                    {(!['issued', 'reject_req', 'rejetion_enabled', 'rejected', 'partialissuecreated', 'accepted'].includes(singleReq_data.curr_status)) && <AssetFormWrapper>
                      {field.map((fld, index) => (
                        <FormItemsCont key={index}>
                          <InputFieldWrap>
                            <AssetNameselCon>
                              <SelectContainer>
                                <Styledlabel>Select Category:</Styledlabel>
                                <CatSelect name='catName' value={fld.catName} onChange={event => handleChange(index, event)}>
                                  <Option value='' selected disabled>Select value</Option>
                                  {applCatarray?.map((elm, index) => (<Option key={index} value={elm}>{elm}</Option>))}
                                </CatSelect>
                              </SelectContainer>
                              <SelectContainer>
                                <Styledlabel>Select Asset Name:</Styledlabel>
                                <SubcatSelect name='assetName' value={field[index].assetName} onChange={event => handleChange(index, event)} >
                                  <Option value='' selected disabled>Select value</Option>
                                  {data?.find(elm => elm.Category === field[index].catName)?.Asset?.map(elm => <Option key={elm.Name} value={elm.Name} >{elm.Name}</Option>)}
                                </SubcatSelect>
                              </SelectContainer>
                            </AssetNameselCon>
                          </InputFieldWrap>
                          <InputFieldWrap>
                            <SelectContainer>
                              <label>Enter Quantity:</label>
                              <input value={fld.quantity} name='quantity' onChange={event => handleChange(index, event)} />
                            </SelectContainer>
                          </InputFieldWrap>
                          <AddButton onClick={() => handleAddClick()}>Add</AddButton>
                          <RemoveButton onClick={() => handleRemoveClick(index)}>Remove</RemoveButton>
                        </FormItemsCont>
                      ))}
                    </AssetFormWrapper>}
                  </AssetFormContainer>
                </FormWrapper>
              </FormContainer>}
            </ExtReqWrapper></>}
        </ReqWrapper>
        {(singleReq_data?.curr_status !== 'rejetion_enabled') && (singleReq_data?.curr_status !== 'rejected') && (singleReq_data?.curr_status !== 'accepted') && remarkButtonClicked && <TextFormCont>
          <HeadingWrap>
            <Span>Details/Justifications</Span>
          </HeadingWrap>
          <JoditEditor
            ref={editor}
            value={content}
            onBlur={newContent => setContent(newContent)}
            onChange={newContent => { }}
          />
        </TextFormCont>}
        {remarkButtonClicked && <ButtonContainer>
          {(!['rejected', 'accepted', 'issued', 'partialissuecreated'].includes(singleReq_data?.curr_status)) && <IntSendBacKButton onClick={handleSendtoboHandler}>Send to Branch Officer</IntSendBacKButton>}
          {(['issued', 'partialissuecreated'].includes(singleReq_data?.curr_status)) && <AcceptAssetsButton onClick={acceptHandler}> Accept Assets </AcceptAssetsButton>}
          {(['issued', 'partialissuecreated'].includes(singleReq_data?.curr_status)) && <RejectionReqButton onClick={rejectionreqHandler}> Request for rejection </RejectionReqButton>}
          {(singleReq_data?.curr_status === 'rejetion_enabled') && <RejectAssetsButton onClick={rejectHandler}>Reject Assets</RejectAssetsButton>}
        </ButtonContainer>}
        {/* request Closure logic */}
        {(['accepted', 'partialissueaccepted'].includes(singleReq_data?.curr_status)) && <RequestClosureWarapperAccepted>{singleReq_data?.curr_status === 'accepted' ? `This Request has been closed. The assets has been accepted by ${singleUser_data?.name?.firstName} ${singleUser_data?.name?.middleName} ${singleUser_data.name?.lastName}-${user_current_office}-${singleUser_data?.designation[user_current_office]} ${singleUser_data?.designationSuffix[user_current_office]}` : `The assets has been partially issued and accepted by${singleUser_data?.name?.firstName} ${singleUser_data?.name?.middleName} ${singleUser_data.name?.lastName}-${user_current_office}-${singleUser_data?.designation[user_current_office]} ${singleUser_data?.designationSuffix[user_current_office]}`} </RequestClosureWarapperAccepted>}
        {(singleReq_data?.curr_status === 'rejected') && <RequestClosureWarapperRejected>This Request has been closed. The assets has been rejected by {`${singleUser_data?.name?.firstName} ${singleUser_data?.name?.middleName} ${singleUser_data.name?.lastName}-${user_current_office}-${singleUser_data?.designation[user_current_office]} ${singleUser_data?.designationSuffix[user_current_office]}`}   </RequestClosureWarapperRejected>}
      </Wrapper>
    </Container>
  )
}

export default InboxForm